@let colorFamily = family();

@if (hasHeader() || visibleRows().length > 0) {
    <div class="table-scroll">
        <table
            [class]="tableClass()"
            [class.table-sized]="!!table().widths"
            [style.--table-accent]="colorFamily.statNumber"
            [style.--table-ink]="colorFamily.statInk"
            [style.--table-fill]="colorFamily.fill"
            [style.--table-on-accent]="colorFamily.onAccent"
            [style.--item-size]="textSize()">
            @if (table().widths; as widths) {
                <colgroup>
                    @for (width of widths; track $index) {
                        <col [style.width.%]="width" />
                    }
                </colgroup>
            }
            @if (hasHeader()) {
                <thead>
                    <tr>
                        @for (column of table().columns; track $index) {
                            <th>{{ column.trim() }}</th>
                        }
                    </tr>
                </thead>
            }
            @if (visibleRows().length > 0) {
                <tbody>
                    @for (row of visibleRows(); track $index) {
                        <tr>
                            @for (cell of row; track $index) {
                                <td>{{ cell.trim() }}</td>
                            }
                        </tr>
                    }
                </tbody>
            }
        </table>
    </div>

    @if (hiddenRows() > 0) {
        <p class="more-rows">+{{ hiddenRows() }}</p>
    }
}
